export default __webpack_public_path__ + "static/media/cookbook.0f4951b0.png";